import { render, staticRenderFns } from "./headerContent.vue?vue&type=template&id=1afe47f0&"
import script from "./headerContent.vue?vue&type=script&lang=js&"
export * from "./headerContent.vue?vue&type=script&lang=js&"
import style0 from "./headerContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports